import { Component } from '@angular/core';
import { AppService } from '@app/app.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {

  document: any = null;

  constructor(
    private appService: AppService
  ) { }

  ngOnInit() {
    this.getDocument();
  }

  getDocument(): void {

    this.appService.getDocument('privacy-policy').subscribe({
      next: (res) => {
        this.document = res.data;
      },
      error: (err) => {
        this.document = null;
      },
    });
  }

}
